import Marquee from "react-fast-marquee";
import { MARQUEE_ITEMS } from "@/data/content";

export const EditorialMarquee = ({ className = "" }) => (
  <div className={`border-y border-white/10 bg-ink-2 py-5 ${className}`} data-testid="editorial-marquee">
    <Marquee speed={35} gradient={false} pauseOnHover>
      {MARQUEE_ITEMS.map((item, i) => (
        <span key={i} className="mx-8 flex items-center gap-16 font-mono text-sm uppercase tracking-[0.35em] text-white/60">
          {item}
          <span className="ml-16 inline-block h-1.5 w-1.5 rotate-45 bg-brand-accent" />
        </span>
      ))}
    </Marquee>
  </div>
);
